// Border-box dimensions; the visible viewport limit wins even below four lines.
export function textareaHeight(content, lineHeight, padding, border, viewportHeight) {
    return Math.ceil(Math.min(Math.max(content + border, 4 * lineHeight + padding + border),
        10 * lineHeight + padding + border, viewportHeight * 0.4));
}
